// import { createPopper } from '@popperjs/core';
import {Tooltip} from "bootstrap";

const tooltipsInit = ()=> {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
}

export default tooltipsInit;
